//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PageTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
  },
};
